export default function NullComponent({ children }) {
  return children || null;
}
